import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "lc_access_token";
const BASE_TOKEN_KEY = "lc_base_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

// Company (base) token kept aside while a vendor session is active
export const baseTokenStore = {
  get: () => localStorage.getItem(BASE_TOKEN_KEY),
  set: (t) => localStorage.setItem(BASE_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(BASE_TOKEN_KEY),
};

const api = axios.create({
  baseURL: API,
  withCredentials: false, // avoid credentialed CORS preflight (use Bearer instead)
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) {
    const m = err?.message || "";
    if (m.includes("Network Error")) return "Erreur de connexion. Vérifiez votre réseau et réessayez.";
    if (m.toLowerCase().includes("timeout")) return "Le serveur met trop de temps à répondre. Réessayez.";
    if ((err?.response?.status || 0) >= 500) return "Erreur du serveur. Réessayez dans un instant.";
    return "Une erreur est survenue. Réessayez.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((e) => {
      const label = fieldLabel(e?.loc);
      const msg = translateValidationMsg(e?.msg);
      return label ? `${label} : ${msg}` : msg;
    });
    return [...new Set(parts)].join(" · ");
  }
  if (typeof detail === "object" && detail.msg) return translateValidationMsg(detail.msg);
  return "Une erreur est survenue.";
}

const FIELD_LABELS = {
  first_name: "Prénom", last_name: "Nom", phone: "Téléphone", email: "Email",
  address: "Adresse", floor: "Étage", elevator: "Ascenseur",
  spiral_staircase: "Escalier colimaçon", custom_slot: "Créneau imposé",
  total_packages: "Nombre de colis", total_weight_kg: "Poids total",
  delivery_date_wanted: "Date souhaitée", distance_km: "Distance",
  oversized_count: "Colis hors gabarit", oversized_details: "Colis hors gabarit",
  departure_address: "Adresse de départ", arrival_address: "Adresse de livraison",
  recipient: "Destinataire", access: "Conditions d'accès",
  kitchen_paid_full: "Règlement de la cuisine", kitchen_premounted: "Cuisine prémontée",
  installer_id: "Poseur/monteur", comment: "Commentaire", pin: "Code PIN",
  password: "Mot de passe", name: "Nom", code: "Code", service_id: "Service",
  depot_address: "Adresse du dépôt", contact_email: "Email de contact",
  contact_phone: "Téléphone de contact", margin_percent: "Marge client",
  company_id: "Entreprise", role: "Rôle", admin_pin: "PIN admin", vendor_id: "Vendeur",
};

function fieldLabel(loc) {
  if (!Array.isArray(loc)) return null;
  for (let i = loc.length - 1; i >= 0; i--) {
    if (typeof loc[i] === "string" && FIELD_LABELS[loc[i]]) return FIELD_LABELS[loc[i]];
  }
  const last = loc[loc.length - 1];
  return typeof last === "string" && last !== "body" ? last : null;
}

function translateValidationMsg(msg) {
  if (!msg) return "valeur invalide";
  const m = String(msg).toLowerCase();
  if (m.includes("field required") || m.includes("missing")) return "champ obligatoire";
  if (m.includes("email")) return "adresse email invalide";
  if (m.includes("valid number") || m.includes("valid integer") || m.includes("parsing")) return "valeur numérique invalide";
  if (m.includes("valid datetime") || m.includes("valid date")) return "date invalide";
  if (m.includes("at least")) return "valeur trop courte";
  if (m.includes("at most")) return "valeur trop longue";
  if (m.includes("greater than")) return "valeur trop petite";
  if (m.includes("less than")) return "valeur trop grande";
  return "valeur invalide";
}
